export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'boltHome' */ 'components/bolt/home/home') },
	'boltIframe': { id: 'boltIframe', page: 'iframe', getter: () => import(/* webpackChunkName: 'boltIframe' */ 'components/bolt/iframe/iframe') },
	'salesforceSignupForm': { id: 'salesforceSignupForm', page: 'salesforceSignupForm', getter: () => import(/* webpackChunkName: 'salesforceSignupForm' */ 'components/bolt/salesforceSignupForm/salesforceSignupForm') },
	'resources': { id: 'resources', page: 'resources', getter: () => import(/* webpackChunkName: 'resources' */ 'components/bolt/resources/resources') },
	'merchandise': { id: 'merchandise', page: 'merchandise', getter: () => import(/* webpackChunkName: 'merchandise' */ 'components/bolt/merchandise/merchandise') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "boltSynopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
